import React from "react";
import { Link } from "react-router-dom";
import Icons from "../common/components/Icons";

const SocialConfect = () => {
  return (
    <div className="pt-8 w-full max-lg:pt-5 max-md:pt-3">
      <div className="w-full flex flex-col gap-4 max-lg:gap-3 max-md:gap-2">
        <div className="w-full flex justify-between items-center max-md:flex-col max-xl:gap-4 max-lg:gap-3 max-md:gap-2 2xl:space-x-5">
          <Link
            to="tel:9253192531"
            className="group py-[16.5px] px-6 rounded bg-white shadow-[0px_0px_24px_0px_#D2D2D28A] w-full max-2xl:max-w-[248px] flex gap-5 hover:bg-custom-green max-xl:max-w-none cursor-pointer">
            {" "}
            <Icons
              className="group-hover:!fill-white"
              icon="innovate-call-icon"
            />{" "}
            <p className="flex flex-col gap-0.5">
              {" "}
              <span className="text-lg font-medium leading-100 pb-0.5 whitespace-nowrap text-custom-black group-hover:text-white">
                Contact Us
              </span>
              <span className="leading-150 text-sm text-custom-black group-hover:text-white">
                9253192531
              </span>
            </p>
          </Link>
          <Link
            to="mailto:info@makewayindia.com"
            className="group py-[16.5px] px-3.5 rounded bg-white shadow-[0px_0px_24px_0px_#D2D2D28A] w-full max-2xl:max-w-[248px] flex gap-5 hover:bg-custom-green max-xl:max-w-none cursor-pointer">
            {" "}
            <Icons
              className="group-hover:!fill-white"
              icon="innovate-mail-icon"
            />{" "}
            <p className="flex flex-col gap-0.5">
              {" "}
              <span className="text-lg font-medium leading-100 pb-0.5 whitespace-nowrap text-custom-black group-hover:text-white">
                Email
              </span>
              <span className="leading-150 text-sm text-custom-black group-hover:text-white">
                info@makewayindia.com
              </span>
            </p>
          </Link>
        </div>
        <Link
          to="#"
          className="group py-[16.5px] px-6 rounded bg-white shadow-[0px_0px_24px_0px_#D2D2D28A] w-full flex gap-5 hover:bg-custom-green max-md:w-full cursor-pointer">
          {" "}
          <Icons
            className="group-hover:!fill-white"
            icon="innovate-location-icon"
          />
          <p className="flex flex-col gap-0.5 max-w-[231px]">
            <span className="text-lg !duration-0 font-medium leading-100 pb-0.5 whitespace-nowrap text-custom-black group-hover:text-white">
              Location
            </span>
            <span className="leading-150 text-sm text-custom-black group-hover:text-white !duration-0">
              Makeway india Opp.Rawalwasia Dharamshala, Bamashah Nagar Hisar
            </span>
          </p>
        </Link>
      </div>
    </div>
  );
};

export default SocialConfect;
